// There is a bug related to first time form render of null (or empty?) fields.  Like htrDevice.
// hack to make everyone a member or esi upon first profile creation.

import React, { useState, useEffect, useContext } from 'react';
import { fetchUserProfile as myfetchUserProfile } from '../fetchUserProfile';
import { GlobalContext } from '../GlobalState'; //need to update global state instead of useState
import {
  useAuthenticator,
  View,
  Flex,
  TextField,
  Button,
  Heading,
  Text,
  Image,
  // FileUploader,
} from '@aws-amplify/ui-react';
// import '@aws-amplify/ui-react/styles.css';
// import Avatar from '@mui/material/Avatar';
import { API, Storage } from 'aws-amplify';
import {
  createUserProfile as createUserMutation,
  updateUserProfile as updateUserMutation,
} from '../../graphql/mutations';

export function ManageProfile() {
  const { user } = useAuthenticator((context) => [context.user]);
  const loggedInUser = `${user.attributes?.sub}::${user.username}`;
  const [userProfile, setUserProfile] = useState();
  const { setProfileData, activeProfile } = useContext(GlobalContext); // not sure what's happening here

  useEffect(() => {
    const fetchProfile = async () => {
      const result = await myfetchUserProfile(user);
      setUserProfile(result);
      console.log(result);
    };
    fetchProfile();
  }, [user]); // this is really confusing to me.  I just want it to run once, but it is squiggles?

  async function createProfile(event) {
    event.preventDefault();
    const form = new FormData(event.target);
    const image = form.get('profileimage');
    const data = {
      username: user.username,
      name: form.get('name'),
      sponsor: form.get('sponsor'),
      sccaid: form.get('sccaid'),
      htrDevice: form.get('htrdevice'),
      groups: ['esi-motorsports_members'], // hack for now assuming everyone on the system is in esi.
      // profileImage: image.name,
    };
    if (image.name !== '') {
      data.profileImage = image.name;
    }
    // needs error handling
    if (!!data.profileImage) await Storage.put(user.username, image); // uses username as filename
    const apiResponse = await API.graphql({
      query: createUserMutation,
      variables: { input: data },
    });
    const result = await myfetchUserProfile(user);
    console.log(result);
    setUserProfile(result);
    setProfileData(result);
    event.target.reset();
  }

  async function updateProfile(event) {
    event.preventDefault();
    const form = new FormData(event.target);
    const image = form.get('profileimage');
    const data = {
      id: userProfile?.id,
      _version: userProfile?._version,
      name: form.get('name'),
      sponsor: form.get('sponsor'),
      sccaid: form.get('sccaid'),
      htrDevice: form.get('htrdevice'),
      // profileImage: image.name,
    };
    if (image.name !== '') {
      data.profileImage = image.name;
    }
    // needs error handling
    if (!!data.profileImage) await Storage.put(user.username, image);
    const apiResponse = await API.graphql({
      query: updateUserMutation,
      variables: { input: data },
    });
    const result = await myfetchUserProfile(user);
    console.log(result);
    setUserProfile(result);
    setProfileData(result);
    event.target.reset();
  }

  return (
    <View textAlign="center">
      <Heading level={1}>Edit your profile</Heading>
      <Flex justifyContent="center">
        {/* if userProfile updateProfile, else createProfile */}
        <View
          as="form"
          width="30rem"
          onSubmit={!userProfile?.id ? createProfile : updateProfile}
        >
          <Flex direction="column" justifyContent="center">
            <TextField
              name="username"
              placeholder={user.username}
              label="Username"
              // variation="quiet"
              isReadOnly={true}
              isDisabled={true}
              descriptiveText={
                <Text
                  as="span"
                  color="purple.60"
                  fontStyle="italic"
                  fontSize="0.8rem"
                >
                  DbOwnerIdentifier:{loggedInUser}
                </Text>
              }
            />
            <TextField
              name="email"
              placeholder={user.attributes?.email}
              label="Email Address"
              descriptiveText={
                <Text
                  as="span"
                  color="purple.60"
                  fontStyle="italic"
                  fontSize="0.8rem"
                >
                  Contact support if you need to change your email address.
                </Text>
              }
              // variation="quiet"
              isReadOnly={true}
              isDisabled={true}
            />
            <TextField
              name="name"
              placeholder="Johnny Swingjuice"
              label="Full Name"
              // variation="quiet"
              defaultValue={userProfile?.name}
            />
            <TextField
              name="sponsor"
              placeholder="Coca Cola"
              label="Sponsor or Team"
              // variation="quiet"
              defaultValue={userProfile?.sponsor}
            />
            <TextField
              name="htrdevice"
              placeholder="htr-001"
              label="HTR streaming device name"
              defaultValue={userProfile?.htrDevice}
            />
            {/* <Avatar
              alt={userProfile?.name}
              src={userProfile?.profileImage}
              sx={{ width: 200, height: 200 }}
            ></Avatar> */}
            <TextField
              name="sccaid"
              placeholder="123456"
              label="SCCA Member Number"
              // variation="quiet"
              descriptiveText={
                <Text
                  as="span"
                  color="purple.60"
                  fontStyle="italic"
                  fontSize="0.8rem"
                >
                  Required to find your race records in RaceHero
                </Text>
              }
              defaultValue={userProfile?.sccaid}
            />
            <View>Profile Picture</View>
            {userProfile?.profileImage && (
              <Image src={userProfile?.profileImage} style={{ width: 400 }} />
            )}
            <View>Change Profile Picture</View>
            <View
              name="profileimage"
              label="Profile Image URL"
              as="input"
              type="file"
              defaultValue={userProfile?.profileImage}
              // style={{ alignSelf: 'end' }}
            />
            <Button type="submit" variation="primary">
              Update Profile
            </Button>
          </Flex>
        </View>
      </Flex>
    </View>
  );
}
